export default {
  url: import.meta.env.VITE_API_URL,
};
